export enum ENoPeriodTableColumns {
  AccountTypeGuid = 'account_type_guid',
  AsseCode = 'asset_code',
  Limits = 'limits',
}
